var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColorPicker',{attrs:{"onChange":_vm.changeColor,"value":_vm.modelVal}})
}
var staticRenderFns = []

export { render, staticRenderFns }